module.exports = __webpack_public_path__ + "static/blog-icerik-146db26a49ecb9b3680ffaaf9694ee16.png";